module.exports = {
	"API_URL": "https://api.konsultacjejst.pl",
	"API_URL___": "https://testapi.konsultacjejst.pl",
	"API_URL__": "https://localhost:55056",
	"API_URL_____": "https://localhost:5001",
	"API_URL_": "https://localhost:44341",
	"AUTH_STATE_ITEM_NAME": "konsultacje_forms_auth_state_local",
	"BUDGET_AUTH_STATE_ITEM_NAME": "konsultacje_budget_forms_auth_state_local",
	"GOOGLE_MAPS_API_KEY": "AIzaSyAUDGJ77tLHxjpToVwHQOcz1hQTxgzDi4c"
};


//////////////////
// WEBPACK FOOTER
// ./src/config/config.local.json
// module id = 1311
// module chunks = 0